import { Box, Typography } from '@mui/material';

import { PrivacyOptions } from '@shared-components-web/assets/SVG';
import { Maybe } from '@shared-components-web/types';
import TAGLink from '@shared-components-web/components/TAGLink';
import {
	isOneTrustLink,
	resolveLinkTitle,
	resolveLinkUrl,
} from '@shared-components-web/components/Footer/Footer.helpers';

type AdFooterFooterPolicyGroupCollection = any;

type NavigationLink = any;

type Page = any;

import { getPolicyGroupStyle, policyLinkStyles } from '@shared-components-web/components/Footer/Footer.styles';

interface IFooterPolicyProps {
	policyGroup: Maybe<AdFooterFooterPolicyGroupCollection>;
}
const PolicyLinks = ({ policyGroup }: IFooterPolicyProps) => {
	const groupItems = policyGroup?.items;

	return (
		<Box data-testid="section_footer_policylinks" sx={getPolicyGroupStyle}>
			{groupItems?.map(
				(link: Maybe<NavigationLink | Page> | undefined, idx) =>
					link && (
						<TAGLink
							key={link.sys.id}
							href={resolveLinkUrl(link)}
							openInNewTab={(link as NavigationLink)?.openInNewTab || false}
							dataTestId={`policy_link_${link.sys.id}`}
							onClick={
								isOneTrustLink(link as NavigationLink)
									? (e) => {
											e.preventDefault();
											window?.OneTrust?.ToggleInfoDisplay();
									  }
									: undefined
							}
						>
							{isOneTrustLink(link as NavigationLink) && (
								<PrivacyOptions
									dataTestId={`privacy_icon_${link?.sys.id ?? idx}`}
									verticalAlign="middle"
								/>
							)}
							<Typography color="text.light" sx={policyLinkStyles} title={resolveLinkTitle(link)}>
								{resolveLinkTitle(link)}
							</Typography>
						</TAGLink>
					)
			)}
		</Box>
	);
};

const FooterPolicy = ({ policyGroup }: IFooterPolicyProps) => {
	return (
		<Box
			data-testid="section_footer_policy"
			flexDirection={{ xs: 'row', md: 'column' }}
			display={'flex'}
			justifyContent={'space-between'}
			gap={2}
		>
			<PolicyLinks policyGroup={policyGroup} />
		</Box>
	);
};

export default FooterPolicy;
